<template>
  <!--:header="ColumnCardHeader" -->
  <el-col :span="columnCardsSpan">
    <el-card shadow="always">
      <el-row>{{ ColumnCardHeader }}</el-row>
      <el-row class="flex-container">
        <el-col :span="6">
          <i class="el-icon-user"></i>
        </el-col>
        <el-col :span="12">
          {{ EmployeesQTY }}
        </el-col>
      </el-row>
    </el-card>
  </el-col>
</template>

<script>
//import { number } from 'yargs';

export default {
  name: "CardTotals",
  props: {
    columnCardsSpan: {
      type: Number,
      default: 8
    },
    ColumnCardHeader: {
      type: String,
      default: "Total"
    },
    EmployeesQTY: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.flex-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
}
</style>
